// Base
import { useState, useEffect } from "react";
import valid from "card-validator";

// Types
import type { FC } from "react";

// Utils
import cc_format from "@/func/cardFormatter";

interface CardFieldProps {
  placeholder?: string;
  error?: string;
  name: string;
  type: string;
  width?: string;
  value: string;
  margin?: string;
  max?: number;
  setValue: (
    name: string,
    value: string,
    options?: { shouldValidate?: boolean; shouldTouch?: boolean },
  ) => void;
  register: (name: string) => Record<string, unknown>;
  contrast?: boolean;
}

const CardField: FC<CardFieldProps> = ({
  placeholder,
  error,
  name,
  type,
  value,
  max,
  setValue,
  register,
  contrast,
}) => {
  const [isValidationActive, _setIsValidationActive] = useState(false);
  const [_creditCardType, setCardType] = useState<string | null>(null);
  const [_isFocused, setIsFocused] = useState(false);

  const formatInputValue = (name: string, value: string) =>
    name === "card_number" ? cc_format(value) : value;

  useEffect(() => {
    const cardData = valid.number(value);
    setCardType(cardData?.card?.type || null);
  }, [value]);

  return (
    <div className="w-full">
      <div className="flex flex-col gap-1">
        <label
          className={`text-sm font-bold whitespace-nowrap ${
            contrast ? "text-cc-dark-gray" : "text-cc-gray"
          }`}
          htmlFor={name}
        >
          {placeholder}
        </label>
        <input
          id={name}
          name={name}
          type={type}
          maxLength={max}
          autoComplete="cc-number"
          {...register(name)}
          value={formatInputValue(name, value)}
          onFocus={() => setIsFocused(true)}
          onChange={(e) =>
            setValue(name, formatInputValue(name, e.target.value), {
              shouldValidate: isValidationActive,
              shouldTouch: true,
            })
          }
          className={`w-full rounded-md border bg-white p-4 text-sm ${
            contrast
              ? "border-cc-gray-5 placeholder-cc-gray-6"
              : "border-cc-gray-4 placeholder-dark-gray"
          }`}
          placeholder={placeholder}
        />
      </div>
      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </div>
  );
};

export default CardField;
